<template>
  <Accordion
    v-for="childKey in sorted(products)"
    :key="childKey"
    :title="childKey"
    :category="childKey"
    :products="products[childKey]"
  />
</template>

<script>
import Accordion from "./Accordion";

export default {
  name: "ProductGroupWrapper",
  components: {
    Accordion,
  },
  props: {
    products: {
      type: Object,
      required: true,
    },
  },
  methods: {
    sorted(products) {
      const keys = Object.keys(products);
      console.debug(keys);
      if (keys.includes("Tehokalkit")) {
        // We are in kalkit.

        // Sorting, this sorts so that tehokalkit is always first, and rakennekalkit is always after that.
        keys.sort((a, b) => {
          if (a === "Tehokalkit") {
            return -1;
          }
          if (b === "Tehokalkit") {
            return 1;
          }
          if (a === "Rakennekalkit" && b !== "Tehokalkit") {
            return -1;
          } else if (b === "Rakennekalkit" && a !== "Tehokalkit") {
            return 1;
          }
          return 0;
        });
      }
      console.debug(keys);
      return keys;
    },
  },
};
</script>

<style scoped></style>
